<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: ZHJI
 * @Date: 2019-08-02 10:06:22
 * @LastEditors: ZHJI
 * @LastEditTime: 2019-11-21 10:34:35
 -->
<!--  -->
<template>
  <div class="PrivateTopicManage">
    <easyCruds
      ref="mainTable"
      :tableInfo="conf.mainTable"
      @mainTableReload="mainTableReload"
      @deleteRows="deleteRows"
      @saveRowByAddOrEdit="saveRowByAddOrEdit"
      @beforeAddViewEdit="beforeAddViewEdit"

      @concatResource="concatResource"
      @concatApp="concatApp"
      @concatFatherPrivate="concatFatherPrivate"
      @concatChildrenPrivate="concatChildrenPrivate"
      @concatFatherPublic="concatFatherPublic"
      @concatChildrenPublic="concatChildrenPublic"
    >
      <localTable ref="extTable" :data="extTable.data"  :allowModify="extTable.allowModify" slot="formSlot"  />
    </easyCruds>

    <!-- Concat Resource -->
     <concatResource ref="concatResource" :isShow="concatTheme.concatResourceShow" :optionRow="concatTheme.optionRow" ></concatResource>
      <!-- Concat private theme -->
     <concatPrivate ref="concatPrivate" :isShow="concatTheme.concatPrivateShow" :optionRow="concatTheme.optionRow" :type="concatTheme.type"></concatPrivate>
    <!-- Concat public theme -->
    <concatPublic ref="concatPublic" :isShow="concatTheme.concatPublicShow" :optionRow="concatTheme.optionRow" :type="concatTheme.type"></concatPublic>
     <!-- Concat APP theme -->
    <concatApp ref="concatApp" :isShow="concatTheme.concatAppShow" :optionRow="concatTheme.optionRow"></concatApp>
  </div>
</template>

<script>
const localTable = () => import('@/framework/components/view/localTable/localTable.vue')

const concatResource = () => import('./internalCpmponents/concatResource/concatResource')

const concatPrivate = () => import('./internalCpmponents/concatPrivate/concatPrivate')

const concatApp = () => import('./internalCpmponents/concatApp/concatApp')

const concatPublic = () => import('./internalCpmponents/concatPublic/concatPublic')

export default {
  data() {
    const mainTable = {
      header: { title: '私有主题管理' },
      buttonSetting: {
        allowAdd: true,
        addText: '新增私有主题',
        addCloseOnClickModal: true,
        beforeAddFunctionName: 'beforeAddViewEdit',
        addButtonArray: [{
          clickEvent: 'saveRowByAddOrEdit',
          type: 'primary',
          buttonName: '新增',
          validate: true
        }],
        allowEdit: true,
        editText: '编辑私有主题',
        editCloseOnClickModal: true,
        editButtonArray: [{
          clickEvent: 'saveRowByAddOrEdit',
          type: 'primary',
          buttonName: '保存编辑',
          validate: true
        }],
        beforeEditFunctionName: 'beforeAddViewEdit',
        allowDelete: true,
        deleteFunctionName: 'deleteRows',
        allowView: true,
        viewText: '查看私有主题',
        viewCloseOnClickModal: true,
        beforeViewFunctionName: 'beforeAddViewEdit',
        left: [{
          title: '关联资源',
          type: 'deflit',
          icon: 'el-icon-circle-plus-outline',
          clickEvent: 'concatResource'
        }, {
          title: '设置父级应用主题',
          type: 'warning',
          icon: '',
          clickEvent: 'concatApp'
        }, {
          title: '设置父级私有主题',
          type: 'primary',
          icon: 'el-icon-sort-up',
          clickEvent: 'concatFatherPrivate'
        }, {
          title: '设置子级私有主题',
          type: 'primary',
          icon: 'el-icon-sort-down',
          clickEvent: 'concatChildrenPrivate'
        }, {
          title: '设置父级公有主题',
          type: 'success',
          icon: 'el-icon-sort-up',
          clickEvent: 'concatFatherPublic'
        }, {
          title: '设置子级公有主题',
          type: 'success',
          icon: 'el-icon-sort-down',
          clickEvent: 'concatChildrenPublic'
        }],
        right: []
      },
      table: {
        loading: false,
        height: 550,
        stripe: true,
        conditionLabelWidth: 'auto',
        selection: true,
        index: false,
        columns: [{
          prop: 'appKey',
          label: '所属应用',
          showInTable: false,
          type: 'select',
          span: 12,
          dicData: [],
          disabled: [false, true, true],
          isSearchCondition: true,
          required: true
        }, {
          prop: 'subjectName',
          label: '名称',
          isSearchCondition: true,
          type: 'input',
          maxlength: 500,
          required: true
        }, {
          prop: 'unifiedId',
          label: '统一ID',
          isSearchCondition: true,
          type: 'input',
          maxlength: 500,
          required: true
        }, {
          prop: 'subjectType',
          label: '类型',
          isTag: true,
          width: '250',
          type: 'select',
          isSearchCondition: true,
          required: true,
          tagFilter: function(e) {
            if (e === 'ORG') {
              return { data: '机构' }
            } else if (e === 'ROLE') {
              return { data: '角色' }
            } else if (e === 'USER') {
              return { data: '用户' }
            } else if (e === 'RESOURCE_GROUP') {
              return { data: '资源组' }
            } else {
              return { data: '其他' }
            }
          },
          dicData: [{
            'label': '资源组',
            'value': 'RESOURCE_GROUP'
          }, {
            'label': '机构',
            'value': 'ORG'
          }, {
            'label': '角色',
            'value': 'ROLE'
          }, {
            'label': '用户',
            'value': 'USER'
          }, {
            'label': '其他',
            'value': 'OTHER'
          }]
        }, {
          prop: 'subjectStatus',
          label: '状态',
          width: '250',
          isTag: true,
          type: 'select',
          isSearchCondition: true,
          required: true,
          tagFilter: function(e) {
            if (e === 1) {
              return { data: '可用', type: 'success' }
            } else {
              return { data: '不可用', type: 'warning' }
            }
          },
          dicData: [{
            'label': '可用',
            'value': 1
          }, {
            'label': '不可用',
            'value': 2
          }]
        }],
        operation: {
          width: '220',
          operations: []
        },
        tableData: [],
        paging: {
          currentPage: 1,
          pageSizes: [15, 20, 25, 30],
          pageSize: 15,
          total: 0
        },
        reload: 'mainTableReload',
        reloadConditions: {},
        addDefultValue: {}
      }
    }
    return { /** 控制扩展字段表,插入的插槽位置 */
      extTable: {
        data: [],
        allowModify: false
      },
      currentAppKey: '',
      conf: { mainTable },
      concatTheme: {
        optionRow: {},
        type: '',
        concatResourceShow: { show: false },
        concatPrivateShow: { show: false },
        concatAppShow: { show: false },
        concatPublicShow: { show: false }
      }
    }
  },
  components: { localTable, concatResource,
    concatPrivate,
    concatApp,
    concatPublic },
  mounted: function() {
    this.$nextTick(() => {
      this.getSelectOPtion()
    })
  },
  methods: {
    /** 获取所属应用 */
    getSelectOPtion: function() {
      this.$http.post('/resource/list-authorized-resource', { entity: {
        'pid': 'Permission.App',
        'appKey': '@PUBLIC'
      }}, { params: { action: 'READ' }}).then(response => {
        let result = []
        response.data.forEach(element => {
          let temp = {}
          element.resourceExtList.forEach(item => {
            if (item.extPropertyKey === 'appName') {
              temp.label = item.extPropertyValue
            } else if (item.extPropertyKey === 'appKey') {
              temp.value = item.extPropertyValue
            }
          })
          result.push(temp)
        })
        this.$refs.mainTable.setColumnSeting('appKey', 'dicData', result)
        if (result.length !== 0) {
          this.conf.mainTable.table.reloadConditions.appKey = result[0].value
          this.$refs.mainTable.reload()
        }
      }).catch(error => {
        this.$message.error(error.msg)
      })
    },
    mainTableReload: function(params) {
      /** This method is triggered when the mainTable dataTables reloads */
      if (!params.appKey) {
        return this.$message.warning('您必须选择一个所属应用才能够进行查询。')
      }
      this.conf.mainTable.table.loading = true
      this.currentAppKey = params.appKey
      this.$http.post('/permission/subject/private/common/query', {
        'entity': {
          'appKey': params.appKey,
          'unifiedId': params.unifiedId,
          'subjectType': params.subjectType,
          'subjectStatus': params.subjectStatus,
          'subjectName': params.subjectName
        }
      }, {
        params: {
          pageNum: params.pageNum || 1,
          pageSize: params.pageSize || 15,
          'searchType': 'NOT_APP'
        }
      }).then(response => {
        this.conf.mainTable.table.loading = false
        /** Successful Business logic */
        this.conf.mainTable.table.tableData = response.data.records
        this.conf.mainTable.table.paging.total = response.data.total || response.data.records.length
      }).catch(error => {
        /** Network error or [.then] code block throw exception */
        this.conf.mainTable.table.loading = false
        this.$message.error(error.msg)
      })
    }, /** Delete data */
    deleteRows: function(deleteList) {
      /** Set mainTable dataTables to loading state */
      this.conf.mainTable.table.loading = true
      this.$http.post('/permission/subject/private/common/delete', deleteList.map(item => {
        return { 'id': item.id, 'appKey': item.appKey }
      })).then(response => {
        this.conf.mainTable.table.loading = false
        this.$message.success('删除私有主题成功！')
        this.mainTableReload(this.$refs.mainTable.getReloadConditions())
      }).catch(error => {
        this.conf.mainTable.table.loading = false
        this.$message.error(error.msg)
      })
    }, beforeAddViewEdit: function(row, optionType, callback) {
      if (optionType === 'ADD') {
        this.setExtTable([], 'ADD') && callback()
      } else {
        this.conf.mainTable.table.loading = true
        /** Control expanded field dataTables add, delete button state */
        this.$http.get('/permission/subject/private/common/' + row.appKey + '/' + row.id).then(response => {
          this.conf.mainTable.table.loading = false
          this.setExtTable(response.data.subjectExtList, optionType) && callback()
        }).catch(error => {
          this.conf.mainTable.table.loading = false
          return this.$message.error(error.msg)
        })
      }
    },
    saveRowByAddOrEdit: function(params, done, errDone, method) {
      params.subjectExtList = this.extTable.data
      this.$http[method === 'EDIT' ? 'put' : 'post']('/permission/subject/private/common', [params]).then(response => {
        this.$message.success('操作成功！') && done()
        this.mainTableReload(this.$refs.mainTable.getReloadConditions())
      }).catch(error => {
        this.$message.error(error.msg) && errDone()
      })
    }, /**
     * 设置扩展字段插槽名称,并控制按钮
     */
    setExtTable: function name(data = [], type) {
      this.extTable.data.splice(0, this.extTable.data.length)
      data.forEach(item => this.extTable.data.push(item))
      if (type === 'VIEW') {
        this.extTable.allowModify = false
      } else {
        this.extTable.allowModify = true
      }

      return true
    },
    /** Concat resource */
    concatResource: function(index, row) {
      this.concatInitialize('concatResource')
    },
    /** Concat APP  theme */
    concatApp: function(index, row) {
      this.concatInitialize('concatApp')
    },
    /** Set the parent private theme */
    concatFatherPrivate: function() {
      this.concatTheme.type = 'up'
      this.concatInitialize('concatPrivate')
    },
    /** Set children private theme */
    concatChildrenPrivate: function() {
      this.concatTheme.type = 'down'
      this.concatInitialize('concatPrivate')
    },
    /** Set the parent public theme */
    concatFatherPublic: function() {
      this.concatTheme.type = 'up'
      this.concatInitialize('concatPublic')
    },
    /** Set the children public theme */
    concatChildrenPublic: function() {
      this.concatTheme.type = 'down'
      this.concatInitialize('concatPublic')
    },
    /** Popover initialization */
    concatInitialize: function(obj) {
      let optionRow = []
      optionRow = this.$refs.mainTable.getSelectedRows()
      if (optionRow.length === 0) {
        return this.$message.warning('请选中一条记录再操作哟。')
      } else if (optionRow.length >= 2) {
        return this.$message.warning('只能选择一行记录进行操作哟')
      }
      if (optionRow[0].status === 2 || optionRow[0].status === '2') {
        return this.$message.warning('您不能对不可用状态的数据进行操作')
      }

      this.concatTheme.optionRow = this.deepClone(optionRow[0])
      /** need to initialize the popover before it opens */
      this.$refs[obj].Initialize()
      this.concatTheme[obj + 'Show']['show'] = true
    }

  }
}
</script>
<style lang='scss' scoped>
</style>
